export default function createUrl(url = '') {
    var fullURL = window.location.href;
    var idx = fullURL.lastIndexOf('/');
    var tmp = fullURL.substring(0, idx+1);

    console.log('createUrl', tmp + url);

    return tmp + url;
}

//const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');

//export default function createUrl(url) {
//    console.log('createUrl', baseUrl + url)
//    return baseUrl + url;
//}
